// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.filters {\n  padding: 0.25rem 0.9rem;\n  margin-bottom: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
